<template>
  <div class="products-page column-me" :class="{'mobile-mode': isMobile}">
    <!-- Banner -->
    <div class="banner-section column-me center-all">
      <div class="section-content">
        <div class="banner-item">
          <transition name="banner-fade" mode="out-in" v-if="carouselImages.length > 0">
            <img :src="carouselImages[carouselIndex]" class="banner-bg" draggable="false" :key="carouselIndex">
          </transition>
          <div class="banner-content" v-if="!isMobile">
            <div class="column-me" v-if="$i18n.locale==='zh-cn'||$i18n.locale==='ja'">
              <img src="../../assets/img/home/home_title1.png" class="w500 objScaleDown" draggable="false">
              <img src="../../assets/img/home/home_title2.png" class="w600 objScaleDown mT20" draggable="false">
            </div>
            <div v-else>
              <img src="../../assets/img/home/home_title11.png" class="h300 objContain" draggable="false">
            </div>
          </div>
          <div class="banner-content font-n" v-if="isMobile">
            <img src="../../assets/img/home/home_title_m.png" class="w220 objContain" draggable="false">
            <div class="font36 font-l mT10" v-if="$i18n.locale==='zh-cn'||$i18n.locale==='ja'">
              悦唯所至 繁复皆<span class="colorOrange">简</span>
            </div>
            <img src="../../assets/img/go.png" class="img70 objFitCover mT40" draggable="false">
          </div>
        </div>
      </div>
    </div>

    <!-- 产品内容 -->
    <div class="content-section column-me center-all pTB80">
      <div class="section-content column-me">
        <!-- 产品分类Tab -->
        <div class="row-me center-all animate-section tab-bar"
             style="background: linear-gradient( 90deg, #F7EEF3 64.84%, #B2C2E3 100%);" ref="tabSection"
             v-if="!isMobile">
          <div class="w1000 row-me row-center flex-sb flex-wrap tab-container">
            <div class="row-me row-center pointer tab-item font-db"
                 v-for="(tab, index) in productTabs" :key="index" :style="{animationDelay: `${index * 0.15}s`}"
                 @click="switchTab(index)">
              <img src="../../assets/img/home/go.png" class="img30" draggable="false" v-if="currentTab===index">
              <img src="../../assets/img/home/go0.png" class="img30" draggable="false" v-else>
              <span class="font32 mL20 break-word alignC"
                    :style="{color:currentTab===index?'#013D5C':'#ABBFCA'}">{{ tab.name || $t(tab.nameKey) }}</span>
            </div>
          </div>
        </div>
        <div class="row-me center-all animate-section tab-bar"
             style="background: #F7EEF3;" ref="tabSection" v-if="isMobile">
          <div class="wh100Per row-me flex-wrap">
            <div class="flex1 pTB25 column-me row-center pointer font-db pLR20"
                 v-for="(tab, index) in productTabs" :key="index" style="height: auto;"
                 :style="{animationDelay: `${index * 0.15}s`,background:currentTab===index?'#e6ebf5':'#fbf8fa'}"
                 @click="switchTab(index)">
              <img src="../../assets/img/home/go.png" class="img30" draggable="false" v-if="currentTab===index">
              <img src="../../assets/img/home/go0.png" class="img30" draggable="false" v-else>
              <div class="flex1 row-me center-all alignC mT10 w150" :class="index===1?'font26':'font30'"
                   :style="{color:currentTab===index?'#013D5C':'#ABBFCA'}">
                {{ tab.name || $t(tab.nameKey) }}
              </div>
            </div>
          </div>
        </div>

        <!-- 产品列表 -->
        <div class="product-list column-me row-center pTB50 overflow-hidden">
          <img src="../../assets/img/products/组%20298.png" class="img-tip objScaleDown" draggable="false"
               v-if="!isMobile && currentProducts.length > 0">
          <!-- 空状态提示 -->
          <div class="empty-state" v-if="currentProducts.length === 0">
            <div class="empty-icon">
              <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="20" y="15" width="80" height="95" rx="6" stroke="#ABBFCA" stroke-width="3" fill="none"/>
                <line x1="35" y1="40" x2="85" y2="40" stroke="#ABBFCA" stroke-width="3" stroke-linecap="round"/>
                <line x1="35" y1="55" x2="75" y2="55" stroke="#ABBFCA" stroke-width="3" stroke-linecap="round"/>
                <line x1="35" y1="70" x2="65" y2="70" stroke="#ABBFCA" stroke-width="3" stroke-linecap="round"/>
                <circle cx="85" cy="85" r="25" fill="#fff" stroke="#EA8063" stroke-width="3"/>
                <path d="M78 85 L83 90 L93 80" stroke="#EA8063" stroke-width="3" stroke-linecap="round"
                      stroke-linejoin="round" fill="none"/>
              </svg>
            </div>
            <div class="empty-title font-db">{{ $t('common.noData') }}</div>
            <div class="empty-desc font-n">{{ $t('common.noDataDesc') }}</div>
          </div>
          <transition name="product-fade" mode="out-in" v-if="currentProducts.length > 0">
            <div class="w100Per" :key="currentTab">
              <div class="product-card w100Per column-me center-all" :class="{'pointer':product.hasRegNumber}"
                   v-for="(product, index) in currentProducts"
                   :key="product.id"
                   @click="goToDetail(product)"
                   :style="{'background':index%2===0?'#FFFFFF':'#f5f7fa', animationDelay: `${index * 0.08}s`}">
                <!-- PC端布局 -->
                <div class="w1000 row-me row-center flex-sb pc-layout" v-if="!isMobile">
                  <div class="product-image flex1" v-if="index%2!==0">
                    <img :src="product.image" style="width: 100%; height: 100%; object-fit: scale-down;"
                         draggable="false">
                  </div>
                  <div class="flex1 product-info column-me pTB30" :class="index%2===0?'':'flex-end2 alignR'">
                    <div class="number-div">{{ index < 10 ? '0' + (index + 1) : index + 1 }}</div>
                    <div class="font40 colorBlue mT20 product-name font-db">{{ product.name }}</div>
                    <div class="font16 mT10 product-code font-l" style="color: #454F5E;">{{ product.code }}</div>
                    <div class="product-btn mT30 pointer" v-if="product.hasRegNumber">
                      <span class="font18 font-n">{{ $t('products.productDetails') }}</span>
                      <el-icon class="mL10">
                        <right/>
                      </el-icon>
                    </div>
                  </div>
                  <div class="product-image flex1" v-if="index%2===0">
                    <img :src="product.image" style="width: 100%; height: 100%; object-fit: scale-down;"
                         draggable="false">
                  </div>
                </div>
                <!-- 手机端布局 -->
                <div class="mobile-layout row-me row-center" v-else>
                  <div class="mobile-product-content" :class="{'reverse': index%2!==0}">
                    <div class="mobile-product-info">
                      <div class="number-div">{{ index < 10 ? '0' + (index + 1) : index + 1 }}</div>
                      <div class="font34 colorBlue mT15 product-name font-db">{{ product.name }}</div>
                      <div class="font14 mT8 product-code font-l" style="color: #454F5E;">{{ product.code }}</div>
                      <div class="product-btn mT120 pointer" v-if="product.hasRegNumber">
                        <span class="font16 font-n">{{ $t('products.productDetails') }}</span>
                        <el-icon class="mL5">
                          <right/>
                        </el-icon>
                      </div>
                    </div>
                    <div class="mobile-product-image">
                      <img :src="product.image" draggable="false">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ArrowRight, Right} from "@element-plus/icons";
import {deviceState} from "@/utils/device";
import {getFirstImage, getImageUrl, getProductCategories, getProductList} from "@/http/api";
import bus from "@/assets/js/bus";

export default {
  components: {
    ArrowRight,
    Right
  },
  data() {
    return {
      deviceState,
      // API返回的产品分类
      apiCategories: [],
      currentTab: 0,
      // API返回的产品列表
      apiProductList: [],
      // 分页信息
      pageNum: 1,
      pageSize: 20,
      total: 0,
      // 轮播相关
      carouselIndex: 0,        // 轮播当前索引
      carouselTimer: null,     // 轮播定时器
      carouselInterval: 4000   // 轮播间隔时间（毫秒）
    }
  },
  computed: {
    // 产品分类Tab列表 - 完全从API获取
    productTabs() {
      if (this.apiCategories && this.apiCategories.length > 0) {
        return this.apiCategories.map((cat) => ({
          id: cat.id,
          nameKey: cat.name,
          name: cat.name,
          icon: getImageUrl(cat.icon)
        }))
      }
      return []
    },
    // 当前选中分类的产品列表 - 完全从API获取
    currentProducts() {
      return this.apiProductList || []
    },
    // 轮播图片列表 - 提取所有分类中有效的icon图片
    carouselImages() {
      if (this.productTabs && this.productTabs.length > 0) {
        return this.productTabs
            .map(tab => tab.icon)
            .filter(icon => icon && icon.trim() !== '')
      }
      return []
    },
    isMobile() {
      return this.deviceState.isMobile
    }
  },
  created() {
    // 接收路由参数，切换到对应的tab
    const tab = this.$route.query.tab
    if (tab !== undefined && tab !== null) {
      const tabIndex = parseInt(tab)
      if (tabIndex >= 0 && tabIndex < 10) { // 临时判断，等分类加载后再验证
        this.currentTab = tabIndex
      }
    }
    // 手机端初始化时检查可见区域
    if (this.isMobile) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkVisibleSections()
        }, 50)
      })
    }
    // 数据加载移到 activated 中，避免首次进入时重复调用
  },
  mounted() {
    this.initScrollAnimation()
    // 确保页面加载时立即检查可见区域
    this.$nextTick(() => {
      this.checkVisibleSections()
    })
    // 监听语言切换事件
    bus.$on('language-changed', this.onLanguageChanged)
    // 启动轮播（如果已有数据）
    if (this.carouselImages.length > 1) {
      this.startCarousel()
    }
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
    bus.$off('language-changed', this.onLanguageChanged)
    // 停止轮播定时器
    this.stopCarousel()
  },
  activated() {
    // 重新加载数据
    this.loadProductData()
    this.$nextTick(() => {
      this.resetAnimations()
      // 重新检查可见区域
      setTimeout(() => {
        this.checkVisibleSections()
      }, 100)
    })
    // 重启轮播
    this.startCarousel()
  },
  deactivated() {
    // 组件失活时停止轮播，避免内存泄漏
    this.stopCarousel()
  },
  methods: {
    // 语言切换时重新加载数据
    onLanguageChanged() {
      this.loadProductData()
    },
    // 启动轮播
    startCarousel() {
      if (this.carouselTimer) {
        return // 已有定时器运行，不重复启动
      }
      if (this.carouselImages.length <= 1) {
        return // 图片少于2张，无需轮播
      }
      this.carouselTimer = setInterval(() => {
        this.nextCarouselSlide()
      }, this.carouselInterval)
    },
    // 停止轮播
    stopCarousel() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer)
        this.carouselTimer = null
      }
    },
    // 切换到下一张轮播图
    nextCarouselSlide() {
      if (this.carouselImages.length === 0) {
        return
      }
      this.carouselIndex = (this.carouselIndex + 1) % this.carouselImages.length
    },
    // 加载产品数据（分类和列表）
    async loadProductData() {
      try {
        // 先加载分类
        const catRes = await getProductCategories()
        if (catRes && catRes.code === 200 && catRes.data) {
          this.apiCategories = catRes.data
          // 分类加载完成后，确保轮播索引有效并启动轮播
          this.$nextTick(() => {
            if (this.carouselIndex >= this.carouselImages.length) {
              this.carouselIndex = 0
            }
            this.startCarousel()
          })
        }
        // 再加载产品列表
        await this.loadProductList()
      } catch (error) {
        console.error('加载产品数据失败:', error)
      }
    },
    // 加载产品列表
    async loadProductList() {
      try {
        const categoryId = this.apiCategories && this.apiCategories.length > this.currentTab
            ? this.apiCategories[this.currentTab].id
            : undefined
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        if (categoryId) {
          params.categoryId = categoryId
        }
        const res = await getProductList(params)
        if (res && res.code === 200 && res.data) {
          this.total = res.data.total || 0
          this.apiProductList = (res.data.list || []).map(item => ({
            id: item.id,
            categoryId: item.categoryId,
            name: item.title,
            code: item.regNumber,
            hasRegNumber: item.hasRegNumber === 1,//是否有注册号：0无 1有
            image: getFirstImage(item.images)
          }))
        }
      } catch (error) {
        console.error('加载产品列表失败:', error)
      }
    },
    // 重置所有动画
    resetAnimations() {
      const sections = [this.$refs.tabSection]

      sections.forEach(section => {
        if (section) {
          section.classList.remove('animate-in')
        }
      })

      this.$nextTick(() => {
        const bannerContent = document.querySelector('.banner-content')
        if (bannerContent) {
          bannerContent.style.animation = 'none'
          setTimeout(() => {
            bannerContent.style.animation = ''
          }, 10)
        }

        const tabItems = document.querySelectorAll('.tab-item')
        tabItems.forEach(item => {
          item.style.animation = 'none'
          setTimeout(() => {
            item.style.animation = ''
          }, 10)
        })
      })
    },
    // 初始化滚动动画
    initScrollAnimation() {
      const options = {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in')
          }
        })
      }, options)

      const sections = [this.$refs.tabSection]

      sections.forEach(section => {
        if (section) {
          this.observer.observe(section)
        }
      })
    },
    // 检查当前视口中可见的区块，立即触发它们的动画
    checkVisibleSections() {
      const sections = [this.$refs.tabSection]

      // 手机端直接触发所有动画，确保内容可见
      if (this.isMobile) {
        sections.forEach(section => {
          if (section) {
            section.classList.add('animate-in')
          }
        })
        return
      }

      sections.forEach(section => {
        if (section) {
          const rect = section.getBoundingClientRect()
          const windowHeight = window.innerHeight || document.documentElement.clientHeight
          const threshold = 0.85

          if (rect.top < windowHeight * threshold && rect.bottom > 0) {
            section.classList.add('animate-in')
          }
        }
      })
    },
    // 切换产品分类Tab
    switchTab(index) {
      this.currentTab = index
      this.pageNum = 1 // 重置页码
      // 重新加载产品列表
      this.loadProductList()
      // 同步更新URL参数
      this.$router.push({
        path: '/products',
        query: {tab: index}
      })
    },
    goToDetail(product) {
      if (!product.hasRegNumber) {
        return
      }
      this.$router.push({
        path: '/productDetail',
        query: {id: product.id}
      })
    }
  },
  watch: {
    '$route.query.tab': {
      handler(newTab, oldTab) {
        if (newTab !== undefined && newTab !== null) {
          const tabIndex = parseInt(newTab)
          if (tabIndex >= 0 && tabIndex < this.productTabs.length) {
            // 检查 tab 是否真正发生变化
            const tabChanged = this.currentTab !== tabIndex
            if (tabChanged) {
              this.currentTab = tabIndex
              // 当从header/footer切换分类时，重新加载产品列表
              this.currentPage = 1
              this.loadProductList()
            }
          }
        }
      },
      immediate: false
    },
    $route: {
      handler(to, from) {
        if (to.path === '/products' && from && from.path !== '/products') {
          setTimeout(() => {
            this.resetAnimations()
            window.scrollTo({top: 0, behavior: 'smooth'})
          }, 50)
        }
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
.products-page {
  width: 100%;
  scroll-behavior: smooth;
}

// 滚动动画
.animate-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;

  &.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
}

// Banner 进入动画
.banner-section {
  .banner-content {
    animation: fadeInUp 1.2s ease-out 0.3s both;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Banner 背景图切换动画
.banner-fade-enter-active {
  transition: all 0.8s ease;
}

.banner-fade-leave-active {
  transition: all 0.5s ease;
}

.banner-fade-enter-from {
  opacity: 0;
  transform: scale(1.1);
}

.banner-fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

// Tab 项动画
.tab-item {
  width: 30%;
  opacity: 0;
  transform: translateY(20px);
  animation: tabFadeIn 0.6s ease-out forwards;
  transition: all 0.3s ease;
  position: relative;
  padding: 10px 0;

  &:nth-child(3n-1) {
    width: 40%;
    justify-content: center;
  }

  &:nth-child(3n) {
    justify-content: flex-end;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 3px;
    background: #EA8063;
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover {
    transform: translateY(-3px);

    &::after {
      width: 80%;
    }

    span {
      color: #EA8063 !important;
    }
  }
}

@keyframes tabFadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 产品列表切换动画
.product-fade-enter-active {
  animation: productFadeIn 0.4s ease-out;
}

.product-fade-leave-active {
  animation: productFadeOut 0.25s ease-in;
}

@keyframes productFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes productFadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
  }
}

// 产品卡片入场动画
.product-card {
  opacity: 0;
  animation: productCardIn 0.5s ease-out forwards;
}

@keyframes productCardIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 空状态样式
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 40px;
  min-height: 400px;
  background: linear-gradient(135deg, #f8f9fc 0%, #fff 100%);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  animation: emptyFadeIn 0.6s ease-out;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;

  .empty-icon {
    width: 120px;
    height: 120px;
    margin-bottom: 30px;
    opacity: 0.9;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .empty-title {
    font-size: 24px;
    color: #2C2B30;
    margin-bottom: 12px;
    text-align: center;
  }

  .empty-desc {
    font-size: 16px;
    color: #ABBFCA;
    text-align: center;
    max-width: 280px;
    line-height: 1.6;
  }
}

@keyframes emptyFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 产品列表样式
.product-list {
  position: relative;

  .img-tip {
    width: 200px;
    position: absolute;
    right: 30px;
    z-index: 10;
  }

  .product-card {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      transition: left 0.6s ease;
    }

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      transform: translateY(-5px);

      &::before {
        left: 100%;
      }

      .product-image img {
        transform: scale(1.05);
      }

      .product-btn {
        background: #FF8C4D;
        transform: translateX(10px);
        box-shadow: 0 4px 12px rgba(234, 128, 99, 0.4);
      }

      .number-div {
        transform: rotate(360deg);
      }
    }

    .product-image {
      height: 500px;
      overflow: hidden;
      padding: 20px;

      img {
        transition: transform 0.6s ease;
      }
    }

    .number-div {
      width: 40px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #EB8063;
      border-radius: 16px 16px 16px 16px;
      font-size: 20px;
      color: #FFFFFF;
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .product-btn {
      display: inline-flex;
      align-items: center;
      width: fit-content;
      padding: 10px 25px;
      background: #EA8063;
      color: #FFFFFF;
      border-radius: 20px;
      font-size: 14px;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 2px 8px rgba(234, 128, 99, 0.2);
    }

    .product-name {
      transition: color 0.3s ease;
    }

    .product-code {
      transition: color 0.3s ease;
    }
  }
}

// 响应式
@media (max-width: 1200px) {
  .product-list {
    grid-template-columns: 1fr !important;
  }
}

// ==================== 手机端适配样式 ====================
.products-page.mobile-mode {
  // Banner 适配 - 与首页保持一致
  .banner-section {
    .section-content {
      width: 100% !important;
      padding: 0 !important;
    }

    .banner-item {
      position: relative;
      width: 100%;
      height: 1020px;
      aspect-ratio: 16 / 9;
      overflow: hidden;

      .banner-bg {
        position: absolute;
        top: inherit;
        left: inherit;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 65%;
        object-fit: cover;
        object-position: right;
      }

      .banner-content {
        position: absolute;
        top: 25%;
        left: 8%;
        display: flex;
        flex-direction: column;
        font-size: 87px;
        line-height: 80px;
        color: #454F5E;
      }
    }
  }

  // 内容区域适配
  .content-section {
    padding: 0 !important;

    .section-content {
      width: 100% !important;
      box-sizing: border-box;
    }
  }

  // Tab栏适配
  .tab-bar {
    height: auto !important;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .tab-container {
      width: 100% !important;
      padding: 0 15px;
      box-sizing: border-box;
      gap: 10px;
      flex-wrap: nowrap;
      justify-content: flex-start !important;

      .tab-item {
        flex-shrink: 0;
        padding: 8px 15px;
        white-space: nowrap;

        .img30 {
          width: 20px !important;
          height: 20px !important;
        }

        span {
          font-size: 16px !important;
          margin-left: 8px !important;
        }
      }
    }
  }

  // 产品列表适配
  .product-list {
    margin-top: 20px !important;

    .product-card {
      padding: 0 !important;

      .mobile-layout {
        width: 100%;
        height: 500px;

        .mobile-product-content {
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 15px;
          overflow: auto;
          padding-left: 60px;
          padding-right: 30px;

          &.reverse {
            flex-direction: row-reverse;
            padding-left: 30px;
            padding-right: 60px;

            .mobile-product-info {
              align-items: flex-end;
              text-align: right;
            }
          }

          .mobile-product-info {
            flex: 1;
            display: flex;
            flex-direction: column;

            .number-div {
              width: 40px;
              height: 40px;
              line-height: 40px;
              font-size: 18px;
              border-radius: 16px;
            }

            .product-name {
              font-size: 34px !important;
              line-height: 1.4;
            }

            .product-code {
              font-size: 12px !important;
            }

            .product-btn {
              padding: 6px 15px;
              border-radius: 15px;
              display: inline-flex;
              width: fit-content;
            }
          }

          .mobile-product-image {
            width: 60%;

            img {
              width: 100%;
              height: 400px;
              object-fit: scale-down;
            }
          }
        }
      }
    }

    // 手机端空状态样式
    .empty-state {
      padding: 60px 40px;
      min-height: 300px;
      margin: 0 60px;
      max-width: none;

      .empty-icon {
        width: 160px;
        height: 160px;
      }

      .empty-title {
        font-size: 32px;
      }

      .empty-desc {
        font-size: 24px;
        max-width: 400px;
      }
    }
  }
}
</style>

